import s from './LinkButton.module.css';
import { Like } from 'components/iconComponent/Like';
import { DisLike } from 'components/iconComponent/DisLike';
import { FavoritesIcon } from 'components/iconComponent/FavoritesIcon';

const { NavLink, useLocation } = require('react-router-dom');

const LinkToLikes = () => {
  const { pathname } = useLocation();
  return (
    <NavLink to="/likes" state={{ path: pathname }}>
      <div className={pathname === '/likes' ? s.link__active : s.link}>
        <Like
          color={pathname === '/likes' ? '#fff' : '#FF868E'}
          width={30}
          height={30}
        />
      </div>
    </NavLink>
  );
};

const LinkToDislikes = () => {
  const { pathname } = useLocation();
  return (
    <NavLink to="/dislikes" state={{ path: pathname }}>
      <div className={pathname === '/dislikes' ? s.link__active : s.link}>
        <DisLike
          color={pathname === '/dislikes' ? '#fff' : '#FF868E'}
          width={30}
          height={30}
        />
      </div>
    </NavLink>
  );
};

const LinkToFavorites = () => {
  const { pathname } = useLocation();
  return (
    <NavLink to="/favourites" state={{ path: pathname }}>
      <div className={pathname === '/favourites' ? s.link__active : s.link}>
        <FavoritesIcon
          color={pathname === '/favourites' ? '#fff' : '#FF868E'}
          width={30}
          height={30}
        />
      </div>
    </NavLink>
  );
};

export { LinkToLikes, LinkToDislikes, LinkToFavorites };
